/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Egifts {
    angular.module("meevo.plugins.egifts", []);
}